import { useQuery } from '@tanstack/react-query';
import { userApi } from '../lib/api';

export function useUserProfile() {
  return useQuery({
    queryKey: ['user-profile'],
    queryFn: async () => {
      const res = await userApi.getProfile();
      return res.data;
    },
  });
}

export function useUserDashboard() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: async () => {
      const res = await userApi.getDashboard();
      return res.data;
    },
  });
}

export function useExamHistory() {
  return useQuery({
    queryKey: ['exam-history'],
    queryFn: async () => {
      const res = await userApi.getExamHistory();
      return res.data;
    },
  });
}

export function useUserBadges() {
  return useQuery({
    queryKey: ['user-badges'],
    queryFn: async () => {
      const res = await userApi.getBadges();
      return res.data;
    },
  });
}
